import { useContext } from 'react';
import {
  DownloadSelectionContext,
  type DownloadSelectionContextValue,
} from './DownloadSelectionProvider';

// Null when the site does not offer batch download: the provider is not mounted.
const useDownloadSelection = (): DownloadSelectionContextValue | null =>
  useContext(DownloadSelectionContext);

export default useDownloadSelection;
